"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.hasLabel = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon"));

var _misc = require("../../misc");

var _tokens = _interopRequireDefault(require("../../tokens"));

var _small;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = {
  small: (_small = {
    width: (0, _misc.pxToRem)(32),
    height: (0, _misc.pxToRem)(16),
    labelWidth: (0, _misc.pxToRem)(12),
    labelHeight: (0, _misc.pxToRem)(12),
    labelMargin: (0, _misc.pxToRem)(2),
    iconMarginLeft: (0, _misc.pxToRem)(28),
    iconMarginRight: (0, _misc.pxToRem)(28),
    iconLineHeight: (0, _misc.pxToRem)(20)
  }, _defineProperty(_small, "iconLineHeight", (0, _misc.pxToRem)(12)), _defineProperty(_small, "iconFontSize", (0, _misc.pxToRem)(10)), _defineProperty(_small, "translateX", (0, _misc.pxToRem)(16)), _small),
  medium: {
    width: (0, _misc.pxToRem)(48),
    height: (0, _misc.pxToRem)(24),
    labelWidth: (0, _misc.pxToRem)(18),
    labelHeight: (0, _misc.pxToRem)(18),
    labelMargin: "".concat((0, _misc.pxToRem)(3), " ").concat((0, _misc.pxToRem)(2)),
    iconMarginLeft: (0, _misc.pxToRem)(48),
    iconMarginRight: (0, _misc.pxToRem)(48),
    iconLineHeight: (0, _misc.pxToRem)(18),
    iconFontSize: (0, _misc.pxToRem)(12),
    translateX: (0, _misc.pxToRem)(26)
  }
};

var hasLabel = function hasLabel(_ref, placementCheck) {
  var label = _ref.label,
      labelPlacement = _ref.labelPlacement;
  var hasLabel = Boolean(label); // when checking for placement as well

  if (placementCheck && labelPlacement) {
    return hasLabel && labelPlacement === placementCheck;
  } // otherwise just return if label is present


  return hasLabel;
};

exports.hasLabel = hasLabel;

var buildStyles = function buildStyles(props) {
  var hasLeftLabel = hasLabel(props, 'start');
  var hasRightLabel = hasLabel(props, 'end');
  var hasTopLabel = hasLabel(props, 'top');
  var hasBottomLabel = hasLabel(props, 'bottom');
  var colorOn = props.theme.palette[props.color].main;
  var colorOff = props.theme.palette.grey[700];
  var opacity = props.disabled ? 0.5 : 1;
  var margin = props.theme.spacing(_tokens["default"].spacingUnitHalf);
  var borderRadius = (0, _misc.pxToRem)(13);
  var size = sizes[props.size];
  var colorWhite = props.theme.palette.common.white;
  return (0, _styledComponents.css)(["padding:0;width:", ";height:", ";opacity:", ";margin:0;margin-left:", ";margin-right:", ";margin-top:", ";margin-bottom:", ";& .MuiSwitch-switchBase{background-color:inherit;padding:0;color:", ";& .MuiSwitch-thumb{width:", ";height:", ";box-shadow:none;}& .MuiIconButton-label{box-shadow:0 ", " ", " rgba(0,35,11,0.2);background-color:", ";border-radius:50%;height:", ";width:", ";margin:", ";& .MuiIcon-root{font-size:", ";line-height:", ";color:", ";margin-right:0;margin-left:", ";}}&.Mui-checked{transform:translateX(", ");& .MuiIconButton-label .MuiIcon-root{margin-right:", ";margin-left:0;}& + .MuiSwitch-track{opacity:1;background-color:", ";}}}& .MuiSwitch-track{border-radius:", ";opacity:1;background-color:", ";}"], size.width, size.height, opacity, hasLeftLabel ? margin : 0, hasRightLabel ? margin : 0, hasTopLabel ? margin : 0, hasBottomLabel ? margin : 0, colorWhite, (0, _misc.pxToRem)(18), (0, _misc.pxToRem)(18), (0, _misc.pxToRem)(2), (0, _misc.pxToRem)(2), colorWhite, size.labelHeight, size.labelWidth, size.labelMargin, size.iconFontSize, size.iconLineHeight, colorWhite, size.iconMarginLeft, size.translateX, size.iconMarginRight, colorOn, borderRadius, colorOff);
};

var StyledFormControlLabel = /*#__PURE__*/(0, _styledComponents["default"])(_core.FormControlLabel).withConfig({
  displayName: "Switch__StyledFormControlLabel"
})(["margin:0;.MuiFormControlLabel-label{color:", ";}"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.grey[800];
});

var LegoSwitch = function LegoSwitch(_ref3) {
  var labelPlacement = _ref3.labelPlacement,
      label = _ref3.label,
      props = _objectWithoutProperties(_ref3, ["labelPlacement", "label"]);

  return _react["default"].createElement(StyledFormControlLabel, {
    control: _react["default"].createElement(_core.Switch, _extends({
      checkedIcon: _react["default"].createElement(_Icon["default"], {
        icon: "check"
      }),
      icon: _react["default"].createElement(_Icon["default"], {
        icon: "times"
      })
    }, props)),
    label: label,
    labelPlacement: labelPlacement
  });
};

var Switch = /*#__PURE__*/(0, _styledComponents["default"])(LegoSwitch).withConfig({
  displayName: "Switch"
})(["", ""], buildStyles);
Switch.defaultProps = {
  size: 'medium',
  color: 'secondary',
  labelPlacement: 'end'
};
var _default = Switch;
exports["default"] = _default;